import React from "react";
//import { Box, Grid, Typography } from "@mui/material";
//import PercentIcon from "@mui/icons-material/Percent";
//import LiveTvIcon from "@mui/icons-material/LiveTv";
//import AccessTimeIcon from "@mui/icons-material/AccessTime";
//import DevicesIcon from "@mui/icons-material/Devices";
//import MovieIcon from "@mui/icons-material/Movie";
//import SignalWifiOffIcon from "@mui/icons-material/SignalWifiOff";
//import StarsIcon from "@mui/icons-material/Stars";
//import SecurityIcon from "@mui/icons-material/Security";
//import UpdateIcon from "@mui/icons-material/Update";
//import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";

export const WhyWatcho=()=> {
    //const features = [
    //    { icon: <PercentIcon fontSize="large" />, text: "Unbeatable Prices" },
    //    { icon: <LiveTvIcon fontSize="large" />, text: "Variety of Content" },
    //    { icon: <AccessTimeIcon fontSize="large" />, text: "Watch At Convenience" },
    //    { icon: <DevicesIcon fontSize="large" />, text: "Multi-Device Compatibility" },
    //    { icon: <MovieIcon fontSize="large" />, text: "No Commercials (or Fewer)" },
    //    { icon: <SignalWifiOffIcon fontSize="large" />, text: "Offline Viewing" },
    //    { icon: <StarsIcon fontSize="large" />, text: "Original Content" },
    //    { icon: <SecurityIcon fontSize="large" />, text: "Parental Controls" },
    //    { icon: <UpdateIcon fontSize="large" />, text: "Continuous Updates" },
    //    { icon: <PlayCircleOutlineIcon fontSize="large" />, text: "Access Anywhere" },
    //];

    return (
        //<Box sx={{ textAlign: "center", padding: "40px", backgroundColor: "#141414" }}>
        //    <Typography
        //        variant="h4"
        //        sx={{ color: "#FFFFFF", fontWeight: "bold", marginBottom: "20px" }}
        //    >
        //        Why Watcho?
        //    </Typography>
        //    <Grid container spacing={4} justifyContent="center">
        //        {features.map((feature, index) => (
        //            <Grid item xs={4} sm={4} md={12/5} key={index} sx={{ color: "#FFFFFF" }}>
        //                {feature.icon}
        //                <Typography variant="subtitle1" sx={{ marginTop: "10px" }}>
        //                    {feature.text}
        //                </Typography>
        //            </Grid>
        //        ))}
        //    </Grid>
        //</Box>
        <div className="Howorks">
            <h2 className="heading-bogy  ">Why Watcho?</h2>
            <div className="features-grid">
                <div className="feature-item">
                    <img src="/Images/image 38.png" alt="Unbeatable Prices Icon"/>
                        <h6>Unbeatable Prices</h6>
                </div>
                <div className="feature-item">
                    <img src="/Images/image 39.png" alt="Variety of Content Icon"/>
                        <h6>Variety of Content</h6>
                </div>
                <div className="feature-item">
                    <img src="/Images/image 40.png" alt="Watch At Convenience Icon"/>
                        <h6>Watch At Convenience</h6>
                </div>
                <div className="feature-item">
                    <img src="/Images/image 41.png" alt="Multi-Device Compatibility Icon"/>
                        <h6>Multi-Device Compatibility</h6>
                </div>
                <div className="feature-item">
                    <img src="/Images/image 42.png" alt="No Commercials Icon"/>
                        <h6>No Commercials</h6>
                </div>
                <div className="feature-item">
                    <img src="/Images/image 43.png" alt="Offline Viewing Icon"/>
                        <h6>Offline Viewing</h6>
                </div>
                <div className="feature-item">
                    <img src="/Images/image 44.png" alt="Original Content Icon"/>
                        <h6>Original Content</h6>
                </div>
                <div className="feature-item">
                    <img src="/Images/image 45.png" alt="Parental Controls Icon"/>
                        <h6>Parental Controls</h6>
                </div>
                <div className="feature-item">
                    <img src="/Images/image 46.png" alt="Continuous Updates Icon"/>
                        <h6>Continuous Updates</h6>
                </div>
                <div className="feature-item">
                    <img src="/Images/image 47.png" alt="Access Anywhere Icon"/>
                        <h6>Access Anywhere</h6>
                </div>

            </div>
        </div>

    );
}
